import { type ReactNode } from "react";

import { Progress } from "~/components/ui/progress";
import { cn } from "~/lib/utils";

type QuestionFlowShellProps = {
  children: ReactNode;
  context: ReactNode;
  headerAction?: ReactNode;
  maxWidthClassName?: string;
  progressAriaLabel: string;
  progressLabel: ReactNode;
  progressMax: number;
  progressValue: number;
  supportingContext?: ReactNode;
};

export function QuestionFlowShell({
  children,
  context,
  headerAction,
  maxWidthClassName = "max-w-4xl",
  progressAriaLabel,
  progressLabel,
  progressMax,
  progressValue,
  supportingContext,
}: QuestionFlowShellProps) {
  return (
    <div className="container mx-auto px-4 pb-7 pt-20 sm:pb-10 md:px-8 lg:pb-14">
      <div className={cn("mx-auto", maxWidthClassName)}>
        <header className="border-b border-border pb-5">
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm font-medium text-foreground">{context}</div>
            {headerAction}
          </div>
          <div className="mt-3 flex items-center justify-between gap-4 text-sm text-muted-foreground">
            <div>{progressLabel}</div>
            {supportingContext && (
              <div className="hidden sm:block">{supportingContext}</div>
            )}
          </div>
          <Progress
            aria-label={progressAriaLabel}
            value={progressValue}
            max={progressMax}
            className="mt-3 h-1.5"
            indicatorClassName="bg-brand-decorative"
          />
        </header>
        {children}
      </div>
    </div>
  );
}
